import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDocument } from '@hooks/useDocument';
import { useAuth } from '@hooks';
import DocumentRow from '@components/DocumentRow';
import { DownloadAllDocuments } from '@components';

const Document = () => {
  const { isAllowed } = useAuth();
  const { documents, addDocument, uploadDocument, downloadAll } = useDocument();
  const { t } = useTranslation();

  return (
    <div className="documentScreen">
      {
        (documents.length > 0 && (
          <>
            <h4>{t('documentation.subTitle')}</h4>
            <p style={{ width: '100%', maxWidth: '100%' }}>
              {t('documentation.messageText1')}
              <br />
              {t('documentation.messageText2')}
              <br />
              {t('documentation.messageText3')}
            </p>
          </>
        ),
        documents.map((documentStatus, i) => (
          <DocumentRow
            key={i}
            index={i}
            id={i}
            data={documentStatus}
            onClick={uploadDocument}
            handleFilesUploaded={addDocument}
          />
        )))
      }
      {isAllowed('DOCUMENT_DOWNLOAD') && downloadAll && <DownloadAllDocuments />}
    </div>
  );
};

export default Document;
